import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c091d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eval-indicator" }
const _hoisted_2 = { class: "eval-indicator__scroll" }
const _hoisted_3 = { class: "eval-indicator__table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-seq" }, "序号", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-name" }, "指标名称", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-ranges" }, "分数区间", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-score" }, "得分", -1))
const _hoisted_8 = {
  key: 0,
  class: "col-action"
}
const _hoisted_9 = {
  key: 1,
  class: "col-add"
}
const _hoisted_10 = ["rowspan"]
const _hoisted_11 = ["rowspan"]
const _hoisted_12 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_13 = { class: "col-ranges" }
const _hoisted_14 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_15 = {
  key: 1,
  class: "range-inputs"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-sep" }, ",", -1))
const _hoisted_17 = { class: "col-score" }
const _hoisted_18 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_19 = ["rowspan"]
const _hoisted_20 = {
  key: 3,
  class: "col-add"
}
const _hoisted_21 = {
  key: 0,
  class: "eval-indicator__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            (!_ctx.isReadonly)
              ? (_openBlock(), _createElementBlock("th", _hoisted_8, "操作"))
              : _createCommentVNode("", true),
            (!_ctx.isReadonly)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (indicator, gIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: gIndex }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicator.ranges, (range, rIndex) => {
                return (_openBlock(), _createElementBlock("tr", { key: rIndex }, [
                  (rIndex === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: "col-seq cell-seq",
                        rowspan: indicator.ranges.length
                      }, _toDisplayString(gIndex + 1), 9, _hoisted_10))
                    : _createCommentVNode("", true),
                  (rIndex === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 1,
                        class: "col-name cell-name",
                        rowspan: indicator.ranges.length
                      }, [
                        (_ctx.isReadonly)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.indicatorNameLabelMap[indicator.indicatorName] || indicator.indicatorName || '-'), 1))
                          : (_openBlock(), _createBlock(_component_a_select, {
                              key: 1,
                              value: indicator.indicatorName,
                              "onUpdate:value": ($event: any) => ((indicator.indicatorName) = $event),
                              class: "eval-full",
                              placeholder: "请选择指标名称",
                              options: _ctx.indicatorNameOptions,
                              onChange: _ctx.emitChange
                            }, null, 8, ["value", "onUpdate:value", "options", "onChange"]))
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_13, [
                    (_ctx.isReadonly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatRange(range) || '-'), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_a_select, {
                            value: range.operator,
                            "onUpdate:value": ($event: any) => ((range.operator) = $event),
                            class: "range-op",
                            options: _ctx.operatorOptions,
                            onChange: () => _ctx.onOperatorChange(range)
                          }, null, 8, ["value", "onUpdate:value", "options", "onChange"]),
                          _createVNode(_component_a_input_number, {
                            value: range.minValue,
                            "onUpdate:value": ($event: any) => ((range.minValue) = $event),
                            class: "range-input",
                            controls: false,
                            placeholder: "数值",
                            onChange: _ctx.emitChange
                          }, null, 8, ["value", "onUpdate:value", "onChange"]),
                          (_ctx.isBracket(range.operator))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_16,
                                _createVNode(_component_a_input_number, {
                                  value: range.maxValue,
                                  "onUpdate:value": ($event: any) => ((range.maxValue) = $event),
                                  class: "range-input",
                                  controls: false,
                                  placeholder: "上限",
                                  onChange: _ctx.emitChange
                                }, null, 8, ["value", "onUpdate:value", "onChange"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (indicator.ranges.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 1,
                                type: "text",
                                class: "btn-remove-range",
                                title: "删除区间",
                                onClick: ($event: any) => (_ctx.removeRange(indicator, rIndex))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" × ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    (_ctx.isReadonly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(range.score ?? '-'), 1))
                      : (_openBlock(), _createBlock(_component_a_input_number, {
                          key: 1,
                          value: range.score,
                          "onUpdate:value": ($event: any) => ((range.score) = $event),
                          class: "score-input",
                          controls: false,
                          min: 0,
                          placeholder: "得分",
                          onChange: _ctx.emitChange
                        }, null, 8, ["value", "onUpdate:value", "onChange"]))
                  ]),
                  (!_ctx.isReadonly && rIndex === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 2,
                        class: "col-action cell-action",
                        rowspan: indicator.ranges.length
                      }, [
                        _createVNode(_component_a_button, {
                          type: "text",
                          danger: "",
                          class: "btn-delete-row",
                          onClick: ($event: any) => (_ctx.removeIndicator(gIndex))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 8, _hoisted_19))
                    : _createCommentVNode("", true),
                  (!_ctx.isReadonly)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                        (rIndex === indicator.ranges.length - 1)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "link",
                              class: "btn-add-range",
                              onClick: ($event: any) => (_ctx.addRange(indicator))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" + 添加区间 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ]),
    (!_ctx.isReadonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_a_button, {
            type: "dashed",
            class: "btn-add-indicator",
            onClick: _ctx.addIndicator
          }, {
            default: _withCtx(() => [
              _createTextVNode(" + 添加指标 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}